// API Configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3200/api';

// App Configuration
export const APP_CONFIG = {
  // Pagination
  DEFAULT_PAGE_SIZE: 20,
  MAX_PAGE_SIZE: 100,
  
  // Grid Configuration
  GRID_CONFIG: {
    defaultColDef: {
      sortable: true,
      filter: true,
      resizable: true,
      minWidth: 100,
    },
    pagination: true,
    paginationPageSize: 20,
    rowSelection: 'single',
    animateRows: true,
  },
  
  // Academician Status Options
  ACADEMICIAN_STATUS: {
    ACTIVE: 'active',
    INACTIVE: 'inactive',
    PENDING: 'pending',
    RETIRED: 'retired'
  },
  
  // Academic Titles
  ACADEMIC_TITLES: [
    'Prof. Dr.',
    'Doç. Dr.',
    'Dr. Öğr. Üyesi',
    'Öğr. Gör. Dr.',
    'Öğr. Gör.',
    'Arş. Gör. Dr.',
    'Arş. Gör.'
  ]
};

// Error Messages
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error occurred. Please check your internet connection.',
  SERVER_ERROR: 'Server error occurred. Please try again later.',
  UNAUTHORIZED: 'Unauthorized access. Please login again.',
  NOT_FOUND: 'Requested resource not found.',
  VALIDATION_ERROR: 'Invalid input data. Please check your input.',
  UNKNOWN_ERROR: 'An unknown error occurred.'
};

// Success Messages
export const SUCCESS_MESSAGES = {
  CREATED: 'Record created successfully.',
  UPDATED: 'Record updated successfully.',
  DELETED: 'Record deleted successfully.',
  SAVED: 'Changes saved successfully.'
};
